import axios from 'axios'
import moment from 'moment'

export default {
    initialize: function () {
        window.ptId = getPtId()
        window.openedByApp = getParamValue('app')
        window.chatToken = getParamValue('chat_token')
        window.chatToken = window.chatToken && window.chatToken !== 'null' ? window.chatToken : 'no_token'
        window.appReceiveLink = getParamValue('receive_link')
        window.appVersion = getParamValue('app_version')
        window.appModel = getParamValue('app_model')
        window.configType = getParamValue('type')
        window.deviceId = getParamValue('device_id')
        window.apiDev = getParamValue('dev')
        window.isSeller = getParamValue('seller')
        window.parameterEmail = getParamValue('email')
        window.parameterName = getParamValue('nome') || getParamValue('name')
        window.parameterMobilePhone = getParamValue('whatsapp') || getParamValue('mobile_phone')
        window.parameterBirthDate = getBirthDateParamValue()
        window.parameterGender = getParamValue('gender')
        window.parameterPosition = getParamValue('position')
        window.parameterPassword = getParamValue('password')
        window.parameterSkipPage = getParamValue('skip_page')
        window.showOnlyKlarnaPacks = getParamValue('klarna')
        window.planPreSelected = getPlanPreSelected()
        window.language = getLanguage()
        window.datepickerLanguage = getDatepickerLanguage()
        window.screenBackgroundColor = getParamValue('screen_background')
        window.filteredPacks = getFilteredPacks()
        window.screenBackgroundColor = window.screenBackgroundColor ? window.screenBackgroundColor : getParamValue('background')
        window.apiKey = getApiKey()
        window.webviewConfig = getWebviewConfig()
        setIndexProperties()
        checkBackground()

        if (window.openedByApp == 'true') {
            window.openedByApp = true
        } else {
            window.openedByApp = false
        }

        function getBirthDateParamValue() {
            const birthDate = getParamValue('birth_date')
            if (birthDate) {
                return birthDate
            }
            const age = getParamValue('age')
            if (age) {
                return moment().subtract(age, 'years').format('YYYY-MM-DD')
            }
            return null
        }

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getPtId() {
            const ptId = getParamValue('pt_id')
            const pt = getParamValue('pt')
            if (ptId) {
                return parseInt(ptId)
            }
            if (pt) {
                if (PTS_IDS && PTS_IDS[pt]) {
                    return PTS_IDS[pt]
                } else {
                    return pt
                }
            }
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag) {
                    return ptTag.id
                }
            }
            return ptId
        }

        function getPlanPreSelected() {
            const planIndex = getParamValue('p')
            if (planIndex || planIndex === 0) {
                return parseInt(planIndex)
            } else {
                return false
            }
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng) {
                return lng
            }
            return 'pt'
        }

        function getDatepickerLanguage() {
            if (window.language === 'en') {
                return 'en-EN'
            }
            if (window.language === 'es') {
                return 'es-ES'
            }
            if (window.language === 'fr') {
                return 'fr-FR'
            }
            return 'pt-PT'
        }

        function getApiKey() {
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1 || tag.id === window.ptId
                })
                if (ptTag && ptTag.api) {
                    return ptTag.api
                }
            }
            return 'common'
        }

        function getWebviewConfig() {
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag && ptTag.webview) {
                    return ptTag.webview
                }
            }
            return null
        }

        function setIndexProperties() {
            if (window.webviewConfig) {
                if (window.webviewConfig.title) {
                    document.title = window.webviewConfig.title
                }
                if (window.webviewConfig.icon) {
                    document.querySelector("link[rel='shortcut icon']").href = window.webviewConfig.icon
                }
            }
        }

        function checkBackground() {
            if (window.screenBackgroundColor) {
                if (document.documentElement && document.documentElement.style) {
                    document.documentElement.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                if (document.body && document.body.style) {
                    document.body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
            }
        }

        function getFilteredPacks() {
            try {
                const packId = getParamValue('pack_id')
                if (packId) {
                    return [parseInt(packId)]
                }
                const packIds = getParamValue('pack_ids')
                if (packIds) {
                    return JSON.parse(packIds).map(function (id) {
                        return parseInt(id)
                    })
                }
            } catch {}
            return null
        }
    },
    refreshEnums: function (enums) {
        try {
            if (window.strings) {
                for (const key in enums) {
                    if (enums[key]) {
                        for (let i = 0; i < enums[key].length; i++) {
                            if (enums[key][i].label) {
                                enums[key][i].label = window.strings[enums[key][i].label]
                                    ? window.strings[enums[key][i].label]
                                    : enums[key][i].label
                            }
                        }
                    }
                }
            }
        } catch (error) {}
        window.enums = enums
    },
    processResponse: function (response, callback) {
        const self = this
        try {
            const responseData =
                response && response.request && response.request.response
                    ? JSON.parse(response.request.response)
                    : {
                          success: false,
                          data: null,
                          message: self.getMessageError(response),
                      }
            callback({
                success: responseData ? responseData.success : false,
                data: responseData ? responseData.data : null,
                message: responseData ? responseData.message : null,
            })
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(),
            })
        }
    },
    getMessageError: function (response) {
        let messageError =
            window.strings && window.strings['server_connection_failed']
                ? window.strings['server_connection_failed']
                : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'
        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }
        return messageError
    },
    getAlertOptions: function () {
        const str = window.strings
            ? window.strings
            : {
                  ok: 'Ok',
                  cancel: 'Cancelar',
              }
        return {
            confirmButtonText: str['ok'],
            cancelButtonText: str['cancel'],
        }
    },
    getLabel: function (items, value) {
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === value) {
                return items[i].label
            }
        }
    },
    getGenders: function () {
        const enums = window.enums
        if (enums) {
            return enums.genders
        } else {
            return []
        }
    },
    getPhysicalConditions: function () {
        const enums = window.enums
        if (enums) {
            return enums.physical_condition
        } else {
            return []
        }
    },
    getGoals: function () {
        const enums = window.enums
        if (enums) {
            return enums.goals
        } else {
            return []
        }
    },
    getPaymentMethods: function () {
        const enums = window.enums
        if (enums) {
            return enums.payment_methods
        } else {
            return []
        }
    },
    getPaymentPacksCategories: function () {
        const enums = window.enums
        if (enums) {
            return enums.payments_packs_categories
        } else {
            return []
        }
    },
    getUserPositions: function () {
        const enums = window.enums
        if (enums) {
            return enums.user_positions
        } else {
            return []
        }
    },
    encodeEmail: function (email) {
        return email.toLowerCase().replace(/ /g, '')
    },
    getFormatDate: function (date) {
        let d = new Date()

        if (date) {
            d = date
        }

        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        const year = d.getFullYear()

        if (month.length < 2) {
            month = '0' + month
        }
        if (day.length < 2) {
            day = '0' + day
        }

        return [year, month, day].join('-')
    },
    getDefaultBirthDate: function () {
        let date = new Date()
        date.setFullYear(date.getFullYear() - 18)
        return this.getFormatDate(date)
    },
    validateSubscriptionFields: function (config) {
        const isAndroid = /Android/i.test(navigator.userAgent)
        if (window.appVersion && config.dev_versions && config.dev_versions.indexOf(window.appVersion) > -1 && !isAndroid) {
            config.dev = true
            config.subscription = false
            for (let i = config.steps.length - 1; i > -1; i--) {
                const step = config.steps[i]
                if (step.fields) {
                    const mobilePhoneIndex = step.fields.findIndex(function (fd) {
                        return fd.id === 'mobile_phone'
                    })
                    if (mobilePhoneIndex > -1) {
                        step.fields.splice(mobilePhoneIndex, 1)
                    }
                    step.fields.forEach(function (fd) {
                        if (fd.id === 'birth_date' || fd.id === 'gender' || fd.id === 'goal_txt') {
                            fd.required = false
                        }
                    })
                }
                if (
                    step.id === 'plans_info' ||
                    step.id === 'currency' ||
                    step.id === 'hotmart_plans' ||
                    step.id === 'subscription_hotmart' ||
                    step.id === 'payments_packs_category' ||
                    step.id === 'payments_pack' ||
                    step.id === 'terms_pt'
                ) {
                    config.steps.splice(i, 1)
                }
                if (step.id === 'questions' && step.fields) {
                    step.fields.forEach(function (fd) {
                        fd.required = false
                    })
                }
                if (step.id === 'success') {
                    step.title = 'account_created_successfully'
                    step.info = 'account_will_be_validated_soon_check_email'
                    delete step.openLink
                }
            }
        }
    },
    refreshAppUrl: function (config) {
        if ((config && config.dev) || window.apiDev) {
            axios.defaults.ptApiUrl = axios.defaults.urls.dev[window.apiKey].base
            axios.defaults.storageApiUrl = axios.defaults.urls.dev[window.apiKey].storage
        }
    },
    useSubscriptionValidation: function (config) {
        try {
            if (config && config.checkout) {
                window.useCheckout = true
            }
            if (config && config.hotmart) {
                window.useHotmart = true
            }
        } catch (error) {}
    },
    setConfigStrings: function (config) {
        if (config.translate) {
            const keys = [
                'title',
                'emptyFailedMessage',
                'subtitle',
                'label',
                'failedMessage',
                'termsFailedMessage',
                'message',
                'info',
                'text',
                'name',
                'parent',
                'title_failed_payment',
                'title_process_payment',
                'title_valid_payment',
                'subtitle_failed_payment',
                'subtitle_process_payment',
                'subtitle_valid_payment',
                'info_failed_payment',
                'info_process_payment',
                'info_valid_payment',
                'promotionalCodeMessage',
                'footerMessage',
            ]
            handleJson(config)

            function handleJson(src) {
                for (const key in src) {
                    if (keys.indexOf(key) > -1) {
                        src[key] = window.strings[src[key]] ? window.strings[src[key]] : src[key]
                    }
                    if (typeof src[key] === 'object') {
                        handleJson(src[key])
                    }
                }
            }
        }
    },
    toCssLinearGradient: function (colors, direction) {
        if (!colors || !colors.length) {
            return null
        }
        return 'linear-gradient(' + (direction || 'to right') + ', ' + colors.join(', ') + ')'
    },
    applyBackgroundStyle: function (element, solidColor, gradientColors) {
        if (!element || !element.style) {
            return
        }
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            element.style.backgroundImage = gradient
            element.style.backgroundColor = 'transparent'
            return
        }
        if (solidColor || solidColor === '') {
            element.style.backgroundColor = solidColor
        }
    },
    applyInputBorderStyle: function (element, borderColor, gradientColors, fillColor, borderWidth) {
        if (!element || !element.style) {
            return
        }
        const width = borderWidth || 1
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            const fill = fillColor || '#fff'
            element.style.setProperty('border', width + 'px solid transparent', 'important')
            element.style.setProperty('background-color', 'transparent', 'important')
            element.style.setProperty('background-image', 'linear-gradient(' + fill + ', ' + fill + '), ' + gradient, 'important')
            element.style.setProperty('background-origin', 'border-box', 'important')
            element.style.setProperty('background-clip', 'padding-box, border-box', 'important')
            return
        }
        if (borderColor) {
            element.style.borderColor = borderColor
        }
        if (borderWidth) {
            element.style.borderWidth = width + 'px'
        }
    },
    getButtonBackgroundStyle: function (solidColor, gradientColors, backgroundImageUrl) {
        const style = {}
        if (backgroundImageUrl) {
            style.backgroundImage = 'url(' + backgroundImageUrl + ')'
            return style
        }
        const gradient = this.toCssLinearGradient(gradientColors)
        if (gradient) {
            style.backgroundImage = gradient
            style.backgroundColor = 'transparent'
            return style
        }
        if (solidColor || solidColor === '') {
            style.backgroundColor = solidColor
        }
        return style
    },
    refreshStyles: function (config, callback) {
        const self = this
        setTimeout(function () {
            const body = document.body
            const inputs = document.getElementsByClassName('v-input__slot')
            const photoButtons = document.getElementsByClassName('app-button-photo')
            const nextButtons = document.getElementsByClassName('app-button-next')
            const backButtons = document.getElementsByClassName('app-button-back')
            const links = document.getElementsByClassName('nav-link')

            if (!config) {
                if (body.style && window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                return true
            }

            if (body.style) {
                if (window.screenBackgroundColor) {
                    body.style.backgroundColor = '#' + window.screenBackgroundColor
                } else {
                    body.style.backgroundColor = config.backgroundColor
                }

                if (config.backgroundImage) {
                    body.style.backgroundImage = 'url(' + config.backgroundImage + ')'
                }
            }
            if (inputs) {
                for (let i = 0; i < inputs.length; i++) {
                    self.applyInputBorderStyle(
                        inputs[i],
                        config.inputBorderColor,
                        config.inputBorderGradient,
                        config.inputBackgroundColor,
                        config.inputBorderWidth,
                    )
                }
            }
            if (nextButtons) {
                for (let i = 0; i < nextButtons.length; i++) {
                    if (nextButtons[i].style) {
                        nextButtons[i].style.color = config.buttons.next.textColor
                        self.applyBackgroundStyle(
                            nextButtons[i],
                            config.buttons.next.backgroundColor,
                            config.buttons.next.backgroundGradient,
                        )
                        if (config.buttons.next.borderRadius && config.buttons.next.borderRadius !== 0) {
                            nextButtons[i].classList.add('radius-inline')
                            nextButtons[i].style.borderRadius = config.buttons.next.borderRadius + 'px'
                        }
                        if (config.buttons.next.height) {
                            nextButtons[i].style.height = config.buttons.next.height
                        }
                    }
                }
            }
            if (backButtons) {
                for (let i = 0; i < backButtons.length; i++) {
                    if (backButtons[i].style) {
                        backButtons[i].style.color = config.buttons.back.textColor
                        self.applyBackgroundStyle(
                            backButtons[i],
                            config.buttons.back.backgroundColor,
                            config.buttons.back.backgroundGradient,
                        )
                        if (config.buttons.back.borderRadius && config.buttons.back.borderRadius !== 0) {
                            backButtons[i].classList.add('radius-inline')
                            backButtons[i].style.borderRadius = config.buttons.back.borderRadius + 'px'
                        }
                        if (config.buttons.back.height) {
                            backButtons[i].style.height = config.buttons.back.height
                        }
                    }
                }
            }
            if (photoButtons) {
                for (let i = 0; i < photoButtons.length; i++) {
                    if (photoButtons[i].style) {
                        photoButtons[i].style.borderColor = config.textColor
                        photoButtons[i].style.color = config.textColor
                    }
                }
            }
            if (links) {
                for (let i = 0; i < links.length; i++) {
                    if (links[i].style) {
                        links[i].style.color = config.textColor
                    }
                }
            }
            if (callback) {
                callback()
            }
        })
    },
    getYoutubeEmbedUrl: function (url) {
        let videoId = ''
        let splitId = url.split('v=')[1]

        if (splitId) {
            const ampersandPosition = splitId.indexOf('&')

            if (ampersandPosition !== -1) {
                videoId = splitId.substring(0, ampersandPosition)
            } else {
                videoId = splitId
            }
        } else {
            splitId = url.split('.be/')[1]

            if (splitId) {
                videoId = splitId
            }
        }

        return 'https://www.youtube.com/embed/' + videoId
    },
    capitalize: function (str) {
        if (str) {
            str = str.trim()
            str = str.toLowerCase()
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
        return str
    },
}
